import moment from 'moment';

/**
 * Formatter for displaying filter selection
 *
 * @param {{}} parameter Filter parameter
 * @param {{}} option Filter option
 * @returns {string} Formatted display name
 */
export function filterStatusDisplayName(parameter, option) {
    if (!option.value) {
        return '';
    }

    if ((parameter.param === 'year' || parameter.name === 'year') && !option.displayName) {
        if (parameter.name !== 'year') {
            return option.value.slice(0, 5) + option.value.slice(-2);
        }
        return option.value;
    }

    return option.displayName || option.value;
}

/**
 * Converts date display from DD MMMM YYYY format to DMMMYY
 *
 * @param {string} rawDate Raw date in format DD MMMM YYYY
 * @returns {string} Date in format DMMMYY
 */
export function shortenDate(rawDate) {
    let prefix = '';

    if (rawDate.indexOf('-') === -1) {
        return moment(rawDate, 'DD MMMM YYYY').format('DMMMYY');
    }

    const matches = rawDate.match(/(\d+)(?: (\w+))?(?: (\d+))? - (\d+) (\w+) (\d+)/);
    const dateTo = moment(`${matches[4]} ${matches[5]} ${matches[6]}`, 'DD MMMM YYYY');
    const dateFrom = moment(
        `${matches[1]} ${matches[2] || matches[5]} ${matches[3] || matches[6]}`,
        'DD MMMM YYYY'
    );

    if (!matches[2]) {
        prefix = dateFrom.format('D');
    } else if (!matches[3]) {
        prefix = dateFrom.format('DMMM');
    } else {
        prefix = dateFrom.format('DMMMYY');
    }

    return `${prefix}-${dateTo.format('DMMMYY')}`;
}



// WEBPACK FOOTER //
// ./src/js/helpers/formatter.js